import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import type { DataConfidenceLevel } from '../../utils/sustainabilityUx';

const LEVEL_COLOR: Record<DataConfidenceLevel, 'success' | 'warning' | 'error'> = {
  high: 'success',
  medium: 'warning',
  low: 'error',
};

export interface DataConfidenceChipProps {
  level: DataConfidenceLevel;
  label: string;
  score: number;
  hints?: string[];
}

export const DataConfidenceChip: React.FC<DataConfidenceChipProps> = ({ level, label, score, hints = [] }) => {
  const tooltip =
    hints.length > 0
      ? `${label} (${score}/100). Improve by: ${hints.join(' ')}`
      : `${label} (${score}/100)`;

  return (
    <Tooltip title={tooltip} arrow>
      <Chip size="small" color={LEVEL_COLOR[level]} variant="outlined" label={label} />
    </Tooltip>
  );
};
